import React, { useEffect, useState } from 'react'
import "./visit-history.scss"
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCapsules, faPills } from '@fortawesome/free-solid-svg-icons';
import { checkDobUnit, convertDobToAge, formatDate, provisionalDxTitle } from '../../utils/common-funtions/common';


const VisitHistorySection = ({ visits }) => {
    const { selectedRole } = useSelector((state) => state.auth);

    return (
        <div className='visit-history'>
            {visits && visits?.map((visit, index) => {
                let reasonForVist = visit?.reasonForVisit?.trim()?.split('\n') || []
                let historyOfPresetIllness = visit?.historyOfPresetIllness?.trim()?.split('\n') || []
                let currentMedication = visit?.currentMedication?.trim()?.split('\n') || []
                let extraNote = visit?.extraNote?.trim()?.split('\n') || []
                let provisionalDx = visit?.provisionalDx?.trim()?.split('\n') || []
                let differentialDx = visit?.differentialDx?.trim()?.split('\n') || []
                return (
                    <div key={index} className='individual-visit-history'>
                        <div className='history-header d-flex justify-content-between'>
                            <label>Date: {visit?.appointmentDate ? formatDate(visit?.appointmentDate?.slice(0, 10)) : formatDate(visit?.createdAt?.slice(0, 10))}</label>
                        </div>
                        <div className='row pb-2 pt-1'>
                            <div className='col-md-6 pt-1 border-right'>
                                <span className='d-block ml-1'>Attending: <strong>{visit?.doctorName}</strong></span>

                                {/* <div>
                                    <table id={`patient-details-table`} className="table table-sm table-hover">
                                        <div className='d-flex flex-wrap justify-content-between patientInfo pb-1 pt-1 mx-1'
                                            style={{ fontSize: "13px" }}>
                                            <p className='mr-2'>Name: <span> {visit?.patientName}</span></p>
                                            <p className='mr-2'>Id: <span> {visit?.patientId}</span></p>
                                            <p className='mr-2'>Age: <span> {convertDobToAge(visit?.patientDob?.slice(0, 10), checkDobUnit(visit?.patientDob)) || " "}</span></p>
                                            <p className='mr-2'>Gender: <span> {visit?.patientGender || " "}</span></p>
                                        </div>
                                    </table>
                                </div> */}

                                {/* <div className='vital-sign-section'>
                                    <div className='d-flex header justify-content-between pl-1 pr-3 ' onClick={() => {
                                    }}>
                                        {visit?.vitals && <label style={{ fontSize: "13px" }} className='mx-1 px-0'>Vital Signs:</label>}
                                    </div>
                                    <div>
                                        <table id={`vital-table`} className="table table-sm table-hover mb-0 ">
                                            <thead>
                                                {visit?.vitals && <tr>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Ht(ft/inch)</th>
                                                    <th scope="col">Wt(kg)</th>
                                                    <th scope="col">Temp(F)</th>
                                                    <th scope="col">BMI</th>
                                                    <th scope="col">BP(mmHg)</th>
                                                    <th scope="col">Hr(/min)</th>
                                                    <th scope="col">SPO2(%)</th>
                                                </tr>}
                                            </thead>
                                            <tbody>
                                                <tr key={index}>
                                                    <td>{visit?.vitals?.height}</td>
                                                    <td>{visit?.vitals?.weight}</td>
                                                    <td>{visit?.vitals?.temperature}</td>
                                                    <td>{visit?.vitals?.bmi}</td>
                                                    <td>{visit?.vitals?.bp}</td>
                                                    <td>{visit?.vitals?.hr}</td>
                                                    <td>{visit?.vitals?.spo2}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div> */}
                                <div className=''>
                                    {reasonForVist?.length > 0 && reasonForVist[0]?.length > 0 && <p className='title'>Reason for visit: </p>}
                                    {reasonForVist?.length > 0 && reasonForVist[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            reasonForVist?.map((reason, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {reason}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {historyOfPresetIllness?.length > 0 && historyOfPresetIllness[0]?.length > 0 && <p className='title'>History of preset illness: </p>}
                                    {historyOfPresetIllness?.length > 0 && historyOfPresetIllness[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            historyOfPresetIllness?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {/* Per-visit free text only. The structured list lives on the
                                        patient, so it is not part of any one visit's history. */}
                                    {currentMedication?.length > 0 && currentMedication[0]?.length > 0 && <p className='title'>Current Medication: </p>}
                                    {currentMedication?.length > 0 && currentMedication[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            currentMedication?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {extraNote?.length > 0 && extraNote[0]?.length > 0 && <p className='title'>Note:</p>}
                                    {extraNote?.length > 0 && extraNote[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            extraNote?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                {/* {
                                    visit?.vitals &&
                                    <div className=''>
                                        <div className=''>
                                            <span className='title'>Vital signs</span>
                                            <div className='d-flex flex-wrap px-1' style={{ fontSize: "13px" }}>
                                                {visit?.vitals?.height > 0 && <p className='mr-2 mb-1'><span
                                                    className=''>H: </span>{visit?.vitals?.height + "ft" || " "}
                                                </p>}
                                                {visit?.vitals?.weight > 0 && <p className='mr-2 mb-1'><span
                                                    className=''>W: </span>{visit?.vitals?.weight + "kg" || " "}
                                                </p>}
                                                {visit?.vitals?.bmi > 0 && <p className='mb-1 mr-2'><span
                                                    className=''>BMI: </span>{visit?.vitals?.bmi || " "}</p>}
                                                {visit?.vitals?.bp?.length > 1 && <p className='mb-1 mr-2'><span
                                                    className=''>BP: </span>{visit?.vitals?.bp || " "} mmHg</p>}
                                                {visit?.vitals?.temperature && <p className='mb-1 mr-2'><span
                                                    className=''>Temp: </span>{visit?.vitals?.temperature + "°F" || " "}
                                                </p>}
                                                {visit?.vitals?.rr && <p className='mb-1 mr-2'><span
                                                    className=''>RR: </span>{visit?.vitals?.rr + "/min" || " "}
                                                </p>}
                                                {visit?.vitals?.spo2 && <p className='mb-1 mr-2'><span
                                                    className=''>SPO2: </span>{visit?.vitals?.spo2 + "%" || " "}
                                                </p>}
                                                {visit?.vitals?.hr && <p className='mb-1 mr-2'><span
                                                    className=''>HR: </span>{visit?.vitals?.hr + "/min" || " "}
                                                </p>}
                                                {visit?.vitals?.note && <p className='mb-1'><span
                                                    className=''>Note: </span>{visit?.vitals?.note}
                                                </p>}

                                            </div>
                                        </div>
                                    </div>
                                } */}
                                <div className=''>
                                    {provisionalDx?.length > 0 && provisionalDx[0]?.length > 0 && <p className='title'>{provisionalDxTitle(selectedRole)}:  </p>}
                                    {provisionalDx?.length > 0 && provisionalDx[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            provisionalDx?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {differentialDx?.length > 0 && differentialDx[0]?.length > 0 && <p className='title'> Differential Diagnosis:</p>}
                                    {differentialDx?.length > 0 && differentialDx[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            differentialDx?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>

                                <div>
                                    {visit?.physicalExams?.length > 0 && <p className='title pb-0 mb-0'>O/E</p>}
                                    <div>
                                        {visit?.physicalExams?.length > 0 && visit?.physicalExams?.map((exam, index) => {
                                            if (exam?.type?.toLowerCase() == 'abnormal' || exam?.type?.toLowerCase() == 'normal') {
                                                let data = exam?.desc?.split('\n') || []
                                                return (<div className='my-0 py-0' key={index} style={{ padding: '4px', margin: '0px' }}>
                                                    {exam?.displayName && <p style={{fontSize: "13px"}} className='py-0 my-0 ml-1'>&#8226;{exam?.displayName} : {exam?.type}</p>}
                                                    {data?.map((d, i) => {
                                                        if (d?.length > 1)
                                                            return (
                                                                <p style={{fontSize: "13px"}} key={i} className='py-0 my-0 ml-1'> &#8226;{d}</p>
                                                            )
                                                    })}
                                                </div>)
                                            }
                                        })}
                                    </div>
                                </div>

                                <div className=''>
                                    {visit?.advices?.length > 0 && <p className='title'>Advices:</p>}
                                    {visit?.advices?.map((advice, index) => {
                                        let adviceArray = advice?.details?.trim().split('\n') || []
                                        return (
                                            adviceArray?.map((data, index) => {
                                                return (
                                                    <p key={"advice" + index} className='option my-0 pb-1 ml-2' style={{ fontSize: "13px" }}>
                                                        &#8226; {data}
                                                    </p>
                                                )
                                            })
                                        )

                                    })}
                                </div>

                                <div className='mb-0'>
                                    {visit?.carePlan?.details?.length > 0 && <p className='title'>Care Plan: <span className='content' dangerouslySetInnerHTML={{ __html: visit?.carePlan?.details }}></span></p>}
                                </div>
                            </div>
                            {/* <>{console.log(visit?.prescriptions?.medicines,"check")}</> */}
                            <div className='col-md-6'>
                                {visit?.medicines?.length > 0 && <small className='title mx-0 px-0 border-bottom'>Medicine list</small>}
                                {
                                    visit?.medicines?.map((medicine, i) => {
                                        return <div key={i} className='d-flex'>
                                            <small>  <FontAwesomeIcon size='xs' className='mt-1 p-0 m-0 mb-2' icon={faPills} /></small>
                                            <small key={index} className=' px-1' style={{ fontSize: "14px", fontStyle: "italic", color: "#088aab" }}>{medicine?.name}</small>
                                            <small key={index} className='px-1' style={{ fontSize: "12px", fontStyle: "italic" }}> {medicine?.sig}</small>
                                            <small key={index} className='px-1' style={{ fontSize: "12px", fontStyle: "italic" }}> ( {medicine?.duration} )</small>
                                        </div>
                                    })
                                }
                                <div>
                                    {visit?.labTests?.length > 0 && <small className='title mx-0 px-0 border-bottom'>Investigation</small>}
                                    {visit?.labTests?.map((labTest, index) => {
                                        return (
                                            <small className='d-block option my-0 pb-1'>
                                                {index + 1}. {labTest?.name}
                                            </small>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default VisitHistorySection
